import { Routes, Route } from 'react-router-dom';


// ==========================================
// IMPORT ALL YOUR PAGES
// ==========================================
import LandingPage from '../LandingScreens/Pages/LandingPage';
import RegistrationPage from '../App/Pages/RegistrationPage';
import LoginPage from '../App/Pages/LoginPage';
import ForgotPasswordPage from '../App/Pages/ForgotPasswordPage';
import ResetPasswordPage from '../App/Pages/ResetPasswordPage';
import InvitationLandingPage from '../App/Pages/InvitationLandingPage';
import ShortLinkRedirectPage from '../App/Pages/ShortLinkRedirectPage';
import TalentDensityFeaturePage from '../App/Pages/TalentDensityFeaturePage';
import SubscriptionPage from '../PaymentAndSubcription/Pages/SubscriptionPage';
import RecruiterCandidateView from '../Shared/Utils/test';
import CandidateDashboard from '../Candidate/Pages/CandidateDashboard';
import CandidateEditProfilePage from '../Candidate/Pages/CandidateEditProfilePage';
import CandidateJobInvitaionListingPage  from '../Candidate/Pages/CandidateJobInvitaionListingPage';
import CandidateInvitePage from '../Candidate/Pages/CandidateInvitePage';
import { CandidateCommandCenterPage } from '../Candidate/CommandCenter/Pages/CandidateCommandCenterPage';

// Recruiter Pages
import RecruiterDashboardPage from '../Recruiter/Pages/RecruiterDashboardPage';
import RecruiterCandidateListingPage from '../Recruiter/Pages/RecruiterCandidateListingPage';
import RecruiterSubscriptionPage from '../Recruiter/Pages/RecruiterSubscriptionPage';
import JobTemplateDashboardPage from '../JobPostTemplate/Pages/JobTemplateDashboardPage';
import CreateJobTemplatePage from '../JobPostTemplate/Pages/CreateJobTemplatePage';
import RecruiterManagementPage from '../Recruiter/Pages/RecruiterManagementPage';
import RecruiterRegistrationPage from '../Recruiter/Pages/RecruiterRegistrationPage';
import SearchFiltersBasedOnSubscriptionPlanPage from '../PaymentAndSubcription/Pages/SearchFiltersBasedOnSubscriptionPlanPage';
import SmartFilterSystemPage from '../SearchFilter/Pages/SmartFilterSystemPage';

// Admin Pages
import AdminDashboardPage from '../Admin/Pages/AdminDashboardPage';
import ArchitectureExperiencePage from '../Admin/Pages/ArchitectureExperiencePage';
import HiringAuthorityPage from '../Admin/Pages/HiringAuthorityPage';
import DecisionSpeedPage from '../Admin/Pages/DecisionSpeedPage';
import ReputationSignalsPage from '../Admin/Pages/ReputationSignalsPage';
import OwnerShipLevelPage from '../Admin/Pages/OwnerShipLevelPage';
import RoleLevelPage from '../Admin/Pages/RoleLevelPage';
import BusinessImpactTypePage from '../Admin/Pages/BusinessImpactTypePage';
import TargateRolePage from '../Admin/Pages/TargateRolePage';
import StartupRiskPreferencePage from '../Admin/Pages/StartupRiskPreferencePage';
import WorkStylePage from '../Admin/Pages/WorkStylePage';
import ProductScalePage from '../Admin/Pages/ProductScalePage';
import WorkFlexibilityPage from '../Admin/Pages/WorkFlexibilityPage';
import CandidateConfigByAdminPage from '../Admin/Pages/CandidateConifgByAdminPage';
import RecruiterConfigByAdminPage from '../Admin/Pages/RecruiterConfigByAdminPage';
import PaymentConfigByAdminPage from '../Admin/Pages/PaymentConfigByAdminPage';
import PaymentSystemConfigPage from '../Admin/Pages/PaymentSystemConfigPage';
import PaymentReturnPage from '../PaymentAndSubcription/Pages/PaymentReturnPage';
import ScoreConfigPage from '../Admin/Pages/ScoreConfigPage';
import ScoreMappingConfigPage from '../Admin/Pages/ScoreMappingConfigPage';
import SearchFilterConfigPage from '../Admin/Pages/SearchFilterConfigPage';
import UserManagementPage from '../Admin/Pages/UserManagementPage';
import UserManagementDetailsPage from '../Admin/Pages/UserManagementDetailsPage';
import UsersAndRecruiterPage from '../Admin/Pages/UsersAndRecruiterPage';
import GenerateInviteLinkPage from '../Admin/Pages/GenerateInviteLinkPage';
import InvitationGateComponent from '../Admin/Components/InvitationGateComponent';
import JumpStartServicePage from '../Admin/Pages/JumpStartServicePage';
import LogViewerPage from '../Admin/Pages/LogViewerPage';
import FeedbackPage from '../Admin/Pages/FeedbackPage';
import AccountDeletionRequestsPage from '../Admin/Pages/AccountDeletionRequestsPage';
import AdminProfilePage from '../Admin/Pages/AdminProfilePage';
import AdminSettingsPage from '../Admin/Pages/AdminSettingsPage';
import FeedbackUserPage from '../Candidate/Pages/FeedbackUserPage';
import { CandidateSearchWithStats } from '../Recruiter/Components/CandidateSearchWithStats';
import RecruiterCandidateListingByStatusPage from '../Recruiter/Pages/RecruiterCandidateListingByStatusPage';
import RecruiterFeedbackPage from '../Recruiter/Pages/RecruiterFeedbackPage';
import RecruiterInvitationListingPage from '../Recruiter/Pages/RecruiterInvitationListingPage';
import TalentIntelligencePage from '../Recruiter/Intelligence/Pages/TalentIntelligencePage';
import RecruiterEditProfilePage from '../Recruiter/Pages/RecruiterEditProfilePage';
import RecruiterSettingsPage from '../Recruiter/Pages/RecruiterSettingsPage';
import PrivateLeadershipNetworkLanding from '../LandingScreens/Pages/PrivateLeadershipNetworkLanding';
import { EarlyRegistrationForm } from '../LandingScreens/Components/EarlyRegistrationForm';
import EarlyAccessPage from '../Admin/Pages/EarlyAccessPage';
import EarlyAccessByRolePage from '../Admin/Pages/EarlyAccessByRolePage';
import DetailsNexGentLandingPage from '../LandingScreens/Components/DetailsNexGentLandingPage';
import NexGentPlatform from '../LandingScreens/Components/NormalNexGentLandingPage';
import { AboutUs } from '../LandingScreens/Components/AboutUs';
import { ContactUs } from '../LandingScreens/Components/ContactUs';
import { TermsAndConditions } from '../LandingScreens/Components/TermsAndConditions';
import { PrivacyPolicy } from '../LandingScreens/Components/PrivacyPolicy';
import EarlyAccessRegistrationPage from '../App/Pages/EarlyAccessRegistrationPage';
import ProtectedRoute from './ProtectedRoute';
import BIDashboardPage from '../BusinessIntelligence/Pages/BIDashboardPage';

import { AdminLayout, CandidateLayout, DataServiceLayout, MasterLayoutContainer, RecruitmentLayout } from './CandidateLayout';
import GrowthOverviewPage from '../Admin/Pages/GrowthOverviewPage';
import GrowthFunnelPage from '../Admin/Pages/GrowthFunnelPage';
import GrowthSourcesPage from '../Admin/Pages/GrowthSourcesPage';
import GrowthCampaignsPage from '../Admin/Pages/GrowthCampaignsPage';
import GrowthContentPage from '../Admin/Pages/GrowthContentPage';
import GrowthProspectsPage from '../Admin/Pages/GrowthProspectsPage';
import GrowthInvitationsPage from '../Admin/Pages/GrowthInvitationsPage';
import GrowthReferralsPage from '../Admin/Pages/GrowthReferralsPage';
import GrowthLimitsPage from '../Admin/Pages/GrowthLimitsPage';
import GrowthEventsPage from '../Admin/Pages/GrowthEventsPage';
import BusinessSupportPage from '../Admin/Pages/BusinessSupportPage';
import BusinessSupportOverviewPage from '../Admin/Pages/BusinessSupportOverviewPage';
import BusinessSupportLinksPage from '../Admin/Pages/BusinessSupportLinksPage';
import BusinessSupportChannelPage from '../Admin/Pages/BusinessSupportChannelPage';
import TakeBackupPage from '../Admin/Pages/TakeBackupPage';
import SystemHealthPage from '../Admin/Pages/SystemHealthPage';
import SeoSetupPage from '../Admin/Pages/SeoSetupPage';
import SystemAnalyticsPage from '../Admin/Pages/SystemAnalyticsPage';
import SmartAnalyticsPage from '../Admin/Pages/SmartAnalyticsPage';
import SmartAnalyticsCompanyPage from '../Admin/Pages/SmartAnalyticsCompanyPage';
import SmartAnalyticsCandidatePage from '../Admin/Pages/SmartAnalyticsCandidatePage';
import DataServiceConnectionsPage from '../Admin/Pages/DataServiceConnectionsPage';
import DataServiceQueryPage from '../Admin/Pages/DataServiceQueryPage';
import DataServiceConsolePage from '../Admin/Pages/DataServiceConsolePage';
import DataServiceSavedQueriesPage from '../Admin/Pages/DataServiceSavedQueriesPage';
import DataServiceAccessPage from '../Admin/Pages/DataServiceAccessPage';
import DataServiceConfigPage from '../Admin/Pages/DataServiceConfigPage';
import DataServiceRecordPage from '../Admin/Pages/DataServiceRecordPage';
import DataServiceHistoryPage from '../Admin/Pages/DataServiceHistoryPage';
import PortalConfigPage from '../Admin/Pages/PortalConfigPage';
import SystemConfigurationPage from '../Admin/Pages/SystemConfigurationPage';
import SystemConfigurationEmailPage from '../Admin/Pages/SystemConfigurationEmailPage';
import EmailHubPage from '../Admin/Pages/EmailHubPage';
import EmailTemplatesPage from '../Admin/Pages/EmailTemplatesPage';
import EmailTriggerPage from '../Admin/Pages/EmailTriggerPage';
import CandidatesDataPage from '../Admin/Pages/CandidatesDataPage';
import SharedDirectoryPage from '../App/Pages/SharedDirectoryPage';
import SystemConfigurationPasswordPage from '../Admin/Pages/SystemConfigurationPasswordPage';
import SystemConfigDetail from '../Admin/Components/SystemConfiguration/SystemConfigDetail';
import RoleAssignmentPage from '../Admin/Pages/RoleAssignmentPage';
import TestLoader from '../Loader/TestLoader';
import CandidateSettingsDashboard from '../Candidate/Components/CandidateSettingsDashboard';
import RefundPolicy from '../LandingScreens/Components/RefundPolicy';
import HowItWorks from '../LandingScreens/Components/HowItWorks';
import RecruiterVerificationPolicy from '../LandingScreens/Components/RecruiterVerificationPolicy';
import CandidateVerificationPolicy from '../LandingScreens/Components/CandidateVerificationPolicy';
import CreditUsagePolicy from '../LandingScreens/Components/CreditUsagePolicy';
import SecurityPolicy from '../LandingScreens/Components/SecurityPolicy';
import FAQPolicy from '../LandingScreens/Components/FAQPolicy';
import CookiePolicy from '../LandingScreens/Components/CookiePolicy';
import TrustTransparency from '../LandingScreens/Components/TrustTransparency';
import CyberCountdown from '../LandingScreens/Components/CyberCountdown';
import CyberCountdownTri from '../LandingScreens/Components/CyberCountdownTri';
import CyberCountdownGanesh from '../LandingScreens/Components/CyberCountdownGanesh';
import StaticSubscriptionUI from '../PaymentAndSubcription/Components/StaticSubscriptionUI';
import OpenSearchComponent from '../Candidate/Components/OpenSearchComponent';

export function AppRouter() {
  return (
    
    <Routes>
      {/* ================= PUBLIC ROUTES ================= */}
      <Route path="/" element={<DetailsNexGentLandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/registration/:inviteCode" element={<RegistrationPage />} />
      <Route path="/invite/:token" element={<InvitationLandingPage />} />
      <Route path="/early-access-registration/:userId" element={<EarlyAccessRegistrationPage />} />
      <Route path="/subscription-plans" element={<SubscriptionPage />} />
      <Route path="/talents" element={<TalentDensityFeaturePage />} />
      <Route path="/early-access" element={<EarlyRegistrationForm />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/terms-and-condition" element={<TermsAndConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/refund-and-cancellation-policy" element={<RefundPolicy />} />
      <Route path="/recruiter-verification-policy" element={<RecruiterVerificationPolicy />} />
      <Route path="/candidate-verification-policy" element={<CandidateVerificationPolicy />} />
      <Route path="/credit-usage-policy" element={<CreditUsagePolicy />} />
      <Route path="/security-policy" element={<SecurityPolicy />} />
      <Route path="/faq-policy" element={<FAQPolicy />} />
      <Route path="/cookie-policy" element={<CookiePolicy />} />
      <Route path="/trust-transparency" element={<TrustTransparency />} />
      <Route path="/prelaunch" element={<CyberCountdownGanesh />} />
      <Route path="/pre-launch-pricing" element={<StaticSubscriptionUI />} />

      {/* Short support links. Public: anyone with a nudge message can land on these, and the
          resolver endpoint is permit-all on the backend. */}
      <Route path="/l/:slug" element={<ShortLinkRedirectPage />} />

      {/* Shared directory. Public: the opaque token is the only credential, and every refinement
          is reported back to the admin's tracking panel. */}
      <Route path="/share/:token" element={<SharedDirectoryPage />} />


      {/* <Route path="/test" element={<OpenSearchComponent />} /> */}

      <Route path="/test" element={<RecruiterCandidateView />} />
      {/* <Route path="/test" element={<CandidateSettingsDashboard />} /> */}

      <Route path="/join/invited-by/:referrer/:inviteCode" element={<InvitationGateComponent />} />
    
      <Route path="/unauthorized" element={<div className="p-8 text-red-600 font-bold">Access Denied: You do not have permission for this area.</div>} />

      {/* ================= PROTECTED CANDIDATE ROUTES ================= */}
      <Route element={<ProtectedRoute allowedRoles={['CANDIDATE']} />}>
        <Route element={
          <MasterLayoutContainer>
            {() => <CandidateLayout />}
          </MasterLayoutContainer>
        }>
          <Route path="/candidate/dashboard" element={<CandidateCommandCenterPage />} />
          <Route path="/candidate/clasic" element={<CandidateDashboard />} />

          {/* <Route path="/candidate/command-center" element={<CandidateCommandCenterPage />} /> */}
          <Route path="/candidate/edit-profile" element={<CandidateEditProfilePage />} />
          <Route path="/candidate/settings" element={<CandidateSettingsDashboard />} />
          <Route path="/invitations/:id" element={<CandidateJobInvitaionListingPage />} />
          <Route path="/candidate/invite-link" element={<CandidateInvitePage />} />
          <Route path="/candidate/feedback" element={<FeedbackUserPage />} />

          {/* Data Service lives inside the candidate's own dashboard layout, so
              it keeps the candidate header and navigation around it. The entry
              point is the query builder: these users consume access, they do
              not manage connections, so there is no connections screen for them
              to land on. */}
          <Route path="/candidate/data-service" element={<DataServiceQueryPage />} />
          <Route path="/candidate/data-service/query" element={<DataServiceQueryPage />} />
        <Route path="/candidate/data-service/saved-queries" element={<DataServiceSavedQueriesPage />} />
        <Route path="/candidate/data-service/history" element={<DataServiceHistoryPage />} />
        {/* The console is only reachable when a configuration grants it; the
            endpoint rejects it otherwise, so the route existing is harmless. */}
        <Route path="/candidate/data-service/console" element={<DataServiceConsolePage />} />

        </Route>
      </Route>

      {/* ================= PROTECTED RECRUITMENT ROUTES ================= */}
      <Route element={<ProtectedRoute allowedRoles={['RECRUITER']} />}>
        {/* PayU's return URL. Outside the recruiter layout on purpose - it is a full-screen
            confirmation, not a page inside the dashboard, and the customer should not see nav
            while it verifies. Still behind the recruiter guard because verification is a
            credentialed call and the payment belongs to whoever is logged in. */}
        <Route path="/payment/return" element={<PaymentReturnPage />} />

        <Route element={
          <MasterLayoutContainer>
            {() => <RecruitmentLayout />}
          </MasterLayoutContainer>
        }>
          <Route path="/recruiter/dashboard" element={<RecruiterDashboardPage />} />
          <Route path="/recruiter/profile" element={<RecruiterEditProfilePage />} />
          <Route path="/recruiter/settings" element={<RecruiterSettingsPage />} />
          <Route path="/recruiter/candidates/listing" element={<RecruiterCandidateListingPage />} />
          <Route path="/recruiter/subscription-plans" element={<RecruiterSubscriptionPage />} />
          <Route path="/recruiter/job-management" element={<JobTemplateDashboardPage />} />
          <Route path="/recruiter/job-template/create" element={<CreateJobTemplatePage />} />
          <Route path="/recruiter/create-recruiter" element={<CreateJobTemplatePage />} />
          <Route path="/recruiter/manage-recruiter" element={<RecruiterManagementPage />} />
          <Route path="/recruiter/invitations" element={<RecruiterRegistrationPage />} />
          <Route path="/recruiter/invitations/listing" element={<RecruiterInvitationListingPage />} />
          <Route path="/recruiter/search-filters" element={<SearchFiltersBasedOnSubscriptionPlanPage />} />
          <Route path="/recruiter/search" element={<SmartFilterSystemPage />} />
          <Route path="/recruiter/feedback" element={<RecruiterFeedbackPage />} />
          <Route path="/recruiter/intelligence" element={<TalentIntelligencePage />} />
          <Route path="/recruiter/candidates/listing/:status" element={< RecruiterCandidateListingByStatusPage/>} />

          {/* Inside the recruiter's own dashboard layout. A recruiter may share
              access with the rest of their company, so they get the team access
              screen too; there is still no connections screen, because
              registering a connection is an admin's job. */}
          <Route path="/recruiter/data-service" element={<DataServiceQueryPage />} />
          <Route path="/recruiter/data-service/query" element={<DataServiceQueryPage />} />
          <Route path="/recruiter/data-service/saved-queries" element={<DataServiceSavedQueriesPage />} />
        <Route path="/recruiter/data-service/history" element={<DataServiceHistoryPage />} />
        <Route path="/recruiter/data-service/config" element={<DataServiceConfigPage />} />
        {/* Granted per recruiter through Team Access, on connections that have
            the console enabled. */}
        <Route path="/recruiter/data-service/console" element={<DataServiceConsolePage />} />

        </Route>
      </Route>

      {/* ================= PROTECTED ADMIN ROUTES ================= */}
      <Route element={<ProtectedRoute allowedRoles={['SUPER_ADMIN']} />}>
        <Route element={
          <MasterLayoutContainer>
            {() => <AdminLayout />}
          </MasterLayoutContainer>
        }>
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="/admin/analytics" element={<BIDashboardPage />} />
          <Route path="/admin/architecture-experience" element={<ArchitectureExperiencePage />} />
          <Route path="/admin/hiring-authority" element={<HiringAuthorityPage />} />
          <Route path="/admin/decision-speed" element={<DecisionSpeedPage />} />
          <Route path="/admin/reputation-signals" element={<ReputationSignalsPage />} />
          <Route path="/admin/owner-ship-level" element={<OwnerShipLevelPage />} />
          <Route path="/admin/role-level" element={<RoleLevelPage />} />
          <Route path="/admin/business-impact" element={<BusinessImpactTypePage />} />
          <Route path="/admin/target-role" element={<TargateRolePage />} />
          <Route path="/admin/startup-risk-preference" element={<StartupRiskPreferencePage />} />
          <Route path="/admin/work-style" element={<WorkStylePage />} />
          <Route path="/admin/product-scale" element={<ProductScalePage />} />
          <Route path="/admin/work-flexibility" element={<WorkFlexibilityPage />} />
          <Route path="/admin/candidate-config" element={<CandidateConfigByAdminPage />} />
          <Route path="/admin/recruiter-config" element={<RecruiterConfigByAdminPage />} />
          <Route path="/admin/payment-config" element={<PaymentConfigByAdminPage />} />
          {/* Gateway keys and plan pricing live on one screen now; the old URL still lands on the
              plans tab it used to show rather than 404ing a link that is already in bookmarks. */}
          <Route
            path="/admin/payment-system-configuration"
            element={<PaymentSystemConfigPage />}
          />
          <Route path="/admin/candidate-score-config" element={<ScoreConfigPage />} />
          <Route path="/admin/candidate-score-mapping-config/:id" element={<ScoreMappingConfigPage />} />
          <Route path="/admin/search-filter-config" element={<SearchFilterConfigPage />} />
          <Route path="/admin/user-management" element={<UserManagementPage />} />
          <Route path="/admin/users/:status/:role" element={<UserManagementDetailsPage />} />
          <Route path="/admin/all-users/:role" element={<UsersAndRecruiterPage />} />
          <Route path="/admin/invite-links" element={<GenerateInviteLinkPage />} />
          <Route path="/admin/jumpstart-config" element={<JumpStartServicePage />} />
          <Route path="/admin/logs" element={<LogViewerPage />} />
          <Route path="/admin/profile" element={<AdminProfilePage />} />
          <Route path="/admin/settings" element={<AdminSettingsPage />} />
          <Route path="/admin/feedback" element={<FeedbackPage />} />
          <Route path="/admin/account-deletion-requests" element={<AccountDeletionRequestsPage />} />
          <Route path="/admin/early-acces/users/:role" element={<EarlyAccessByRolePage />} />
          <Route path="/admin/all/early-acces/users/" element={<EarlyAccessPage />} />

          <Route path="/admin/growth" element={<GrowthOverviewPage />} />
          <Route path="/admin/growth/funnel" element={<GrowthFunnelPage />} />
          <Route path="/admin/growth/sources" element={<GrowthSourcesPage />} />
          <Route path="/admin/growth/campaigns" element={<GrowthCampaignsPage />} />
          <Route path="/admin/growth/content" element={<GrowthContentPage />} />
          <Route path="/admin/growth/prospects" element={<GrowthProspectsPage />} />
          <Route path="/admin/growth/invitations" element={<GrowthInvitationsPage />} />
          <Route path="/admin/growth/referrals" element={<GrowthReferralsPage />} />
          <Route path="/admin/growth/limits" element={<GrowthLimitsPage />} />
          <Route path="/admin/growth/events" element={<GrowthEventsPage /> } />

          {/* Business Support. The overview ranks the channels; Generate Link leads the detail
              tabs because it is where a new campaign starts. The channel route validates its own
              segment, so an unknown channel redirects here rather than showing an empty table. */}
          <Route path="/admin/support" element={<BusinessSupportPage />} />
          <Route path="/admin/support/overview" element={<BusinessSupportOverviewPage />} />
          <Route path="/admin/support/links" element={<BusinessSupportLinksPage />} />
          <Route path="/admin/support/channels/:channel" element={<BusinessSupportChannelPage />} />

          {/* Email hub: template configuration lives alongside the send trigger surface. */}
          <Route path="/admin/support/email" element={<EmailHubPage />} />
          <Route path="/admin/support/email/templates" element={<EmailTemplatesPage />} />
          <Route path="/admin/support/email/trigger" element={<EmailTriggerPage />} />

          {/* Candidates Data: candidate/recruiter directory with share links, tracking and onboarding. */}
          <Route path="/admin/support/candidates-data" element={<CandidatesDataPage />} />

          {/* Take Backup: the backup listing with its filters, and the DB configuration that
              decides where an environment's dumps are written. Super admin only. */}
          <Route path="/admin/support/backup" element={<TakeBackupPage />} />

          {/* System Health: VPS services, metrics, logs, incidents and monitoring settings. */}
          <Route path="/admin/support/system-health" element={<SystemHealthPage />} />

          {/* SEO Setup: per page titles, descriptions, canonical URLs, Open Graph, the sitemap
              and the robots file, all editable from the admin. */}
          <Route path="/admin/support/seo-setup" element={<SeoSetupPage />} />

          <Route path="/admin/system-analytics" element={<SystemAnalyticsPage /> } />
          <Route path="/admin/smart-analytics" element={<SmartAnalyticsPage />} />
          <Route path="/admin/smart-analytics/company/:companyId" element={<SmartAnalyticsCompanyPage />} />
          <Route path="/admin/smart-analytics/candidate/:userId" element={<SmartAnalyticsCandidatePage />} />
<Route path="/admin/settings/portal-config" element={<PortalConfigPage />} />
          <Route path="/admin/settings/system-config" element={<SystemConfigurationPage />} />
          <Route path="/admin/settings/system-config/:category" element={<SystemConfigDetail />} />
          <Route path="/admin/settings/email-config" element={<SystemConfigurationEmailPage />} />
          <Route path="/admin/settings/password-config" element={<SystemConfigurationPasswordPage />} />

          {/* Data Service - super admin surface */}
          <Route path="/admin/data-service" element={<DataServiceConnectionsPage />} />
          <Route path="/admin/data-service/query" element={<DataServiceQueryPage />} />
          <Route path="/admin/data-service/console" element={<DataServiceConsolePage />} />
          <Route path="/admin/data-service/saved-queries" element={<DataServiceSavedQueriesPage />} />
          <Route path="/admin/data-service/history" element={<DataServiceHistoryPage />} />
          <Route path="/admin/data-service/access" element={<DataServiceAccessPage />} />
          <Route path="/admin/data-service/config" element={<DataServiceConfigPage />} />

        </Route>
      </Route>

      {/* ============ ROLE MANAGEMENT (SUPER_ADMIN or privileged DELEGATED_ADMIN) ============ */}
      <Route
        element={
          <ProtectedRoute
            allowedRoles={['SUPER_ADMIN', 'DELEGATED_ADMIN']}
            allowedPrivileges={['ROLE_UPDATE', 'ASSIGN_ROLE']}
            requireAllPrivileges
          />
        }
      >
        <Route
          element={
            <MasterLayoutContainer>
              {() => <AdminLayout />}
            </MasterLayoutContainer>
          }
        >
          <Route path="/admin/support/role-assignment" element={<RoleAssignmentPage />} />
        </Route>
      </Route>

      {/* ============ DELEGATED ADMIN: DATA SERVICE ONLY ============ */}
      {/* A delegate is a read-only data-service role, so it gets the data
          service routes and nothing else. The server enforces the same
          ceiling on every request regardless of what the UI shows. */}
      <Route element={<ProtectedRoute allowedRoles={['DELEGATED_ADMIN']} />}>
        <Route element={
          <MasterLayoutContainer>
            {() => <DataServiceLayout />}
          </MasterLayoutContainer>
        }>
          <Route path="/data-service" element={<DataServiceConnectionsPage />} />
          <Route path="/data-service/query" element={<DataServiceQueryPage />} />
          <Route path="/data-service/saved-queries" element={<DataServiceSavedQueriesPage />} />
          <Route path="/data-service/history" element={<DataServiceHistoryPage />} />
        </Route>
      </Route>

      {/* ============ RECORD DETAIL (ALL DATA-SERVICE ROLES) ============ */}
      {/* Opened in a new tab from a result row, so it renders standalone rather
          than inside any one dashboard shell - a recruiter drilling into a
          candidate and a super admin drilling into the same row should land on
          the same screen. Read access is re-checked per request by the query
          endpoint it calls, exactly as it is for the grid the row came from. */}
      <Route
        element={
          <ProtectedRoute
            allowedRoles={['SUPER_ADMIN', 'DELEGATED_ADMIN', 'RECRUITER', 'CANDIDATE']}
          />
        }
      >
        <Route path="/data-service/record" element={<DataServiceRecordPage />} />
      </Route>

      {/* ============ CONFIGURED RECRUITERS AND CANDIDATES ============ */}
      {/* These two roles reach data service through a configuration rather than
          a per-user grant, so they get a deliberately smaller surface, and it
          sits inside their own dashboard layout rather than in a separate
          data-service shell - see the routes added to the recruiter and
          candidate groups above. No console, no access management, and no
          connection management: the server refuses all three regardless of
          what this route list shows. */}
    </Routes>
  );
}